import { FarmsState } from './types';
export default {
  isFetching: (state: FarmsState) => state.status.startsWith('fetching'),
  isFetchingFarmList: (state: FarmsState) => state.farmListStatus.startsWith('fetching'),
};
